Core.ProductListing = {
    init: function () {
        this.initAccordion();
    },
    variants: {
        init: function () {
            Core.ProductListing.Cache = {
                $variants: $('.product-details__variants')
            };

            //var _$groupPrice = $('#groupPrice');

            Core.AddToQuote.Cache.$groupPrice = $('#groupPrice');
            Core.AddToQuote.Cache.$groupCode = $('#groupCode');

            function updateVariantQuantity() {                
                if (this.value() === null) {
                    this.value(1);
                }

                // set selectedVariants if undefined
                if (typeof selectedVariants === 'undefined') {
                    selectedVariants = [];
                }

                var _sku = $(this.element).data('id'),
                    _qty = this.value(),
                    _groupPrice = 0;

                for (var i = 0; i < window.selectedVariants?.length; i++) {
                    if (window.selectedVariants[i]['sku'] == _sku) {
                        window.selectedVariants[i].qty = _qty;
                        break;
                    }
                }

                for (var x = 0; x < selectedVariants?.length; x++) {
                    _groupPrice += parseFloat(selectedVariants[x].price * selectedVariants[x].qty);
                }

                if (_groupPrice === 0) {
                    Core.AddToQuote.Cache.$groupPrice.text(Core.Config.POA.Text).show();
                }
                else {
                    Core.AddToQuote.Cache.$groupPrice.text('$' + _groupPrice.toFixed(2)).show();
                }

                // $(this.element).trigger('input');
                // $(this.element).trigger('blur'); // prevent call api twice after changing using spinner
            }

            /*
            var handleQtyChange = Core.Util.Debounce(function($row) {                       
                Core.ProductListing.checkLocalStockVariant($row);                
            }, 300);
            */

            $(".product-details__variant--qty").each(function(index, element) {
                var $elem = $(element);
                var $row = $elem.closest('.plv__variant-row')

                // Check if element has been initialized
                if ($elem.hasClass('k-widget') ||
                    $elem.hasClass('k-input') ||
                    $elem.hasClass('k-numerictextbox') ||
                    $elem.hasClass('k-input-inner')) {
                    return;
                }

                $elem.kendoNumericTextBox({
                    format: "#",
                    step: 1,
                    change: updateVariantQuantity,
                    spin: updateVariantQuantity
                });
                
                /*
                if (`${$('#product-listing').data('list-view')}`?.toLowerCase() === 'true') {
                    $row.find('.k-icon-button').on('click', function() {
                        handleQtyChange($row);
                    });

                    $row.find('input.product-details__variant--qty').on('change', function() {                        
                        handleQtyChange($row);
                    });
                }
                */
            });
        }
    },
    clearSelections: function () {
        window.selectedVariants = [];
    },
    setItemHeight: function () {
        var $prodDetails = document.querySelectorAll('.product-details.is-portalsite');
        if ($prodDetails) Core.Util.setFakeRowHeights($prodDetails);
    },
    initAccordion: function () {
        if ($("#plv__panelbar").length === 0) return;

        $("#plv__panelbar").kendoPanelBar({
            expand: function(e) {
                var plp = Core.ProductListing;
                var $panelItem = $(e.item);
                plp.variants.init();
                plp.checkStockPanel($panelItem);
            },
        });
    },
    checkStockPanel: function($panelItem) {
        var CLS_HIDE = 'd-none';
        var CLS_CHECKED = 'has-checked';

        if ($panelItem.hasClass(CLS_CHECKED)) return;

        var $page = $('#product-listing');
        var api = $page.data('check-local-stock-api');
        var variants = [];

        var $rows = $panelItem.find('.plv__variant-row');
        var location = {
            suburb: $page.attr('data-suburb'),
            state: $page.attr('data-state'),
            postCode: $page.attr('data-postcode'),
        };

        $rows.each(function(i, row) {
            var $qty = $(row).find('input[name="qty"]');
            variants.push({
                qty: $qty.val(),
                sku: $qty.data('id'),
            });
        });

        $.ajax({
            url: api,
            data: {
                variants: variants,
                location: location,
                setLocation: false,
            },
            type: 'POST',
            dataType: 'json',
            success: function(data) {  
                $panelItem.addClass(CLS_CHECKED);
                
                if (data.isSuccess) {
                    var stockData = data.stocks;
                    
                    if (stockData.length > 0) {
                        stockData.forEach(function(item, index) {
                            var $row = $panelItem.find(`.plv__variant-row[data-id="${item.sku}"]`);
                            if ($row.length === 0) return;
            
                            // keep stock-national if no value
                            if (Core.Util.isEmpty(item.value)) {
                                return;
                            }
            
                            var $local = $row.find(`.stock-local`);
                            $local.find('.stock-status').css('background-color', item.colour);
                            $local.find('.stock-message').html(`${item.value}`);
                            $local.addClass(CLS_CHECKED);
                            $row.find(`.stock-national`)?.addClass(CLS_HIDE);
                        });
                    }
                } else {
                    console.log('error', data.message);
                }
            },
            error: function(xhr, ajaxOptions, thrownError) {        
                console.log('error', xhr, ajaxOptions, thrownError);
            }
        });
    },
    checkLocalStockVariant: function($row) {
        var $page = $('#product-listing');
        var api = $page.data('check-local-stock-api');
        if (!api) {
            console.log('Please provide the api url for stock check (data-check-local-stock-api)');
            return;
        }

        var $qty = $row.find('input[name="qty"]');
        var variants = [{
            qty: $qty.val(),
            sku: $qty.data('id'),
            mainsku: $qty.data('id'),
        }];

        $.ajax({
            url: api,
            data: {
                variants: variants,
                setLocation: false,
            },
            type: 'POST',
            dataType: 'json',
            success: function(data) {
                if (data.isSuccess) {
                    var item = data.stocks?.length > 0 && data.stocks[0];
                    if (!item) return;

                    var $local = $row.find(`.stock-local`);
                    $local.find('.stock-status').css('background-color', item.colour);
                    $local.find('.stock-message').html(item.value);
                    $local.addClass(CLS_CHECKED);
                }
            },
            error: function(xhr, ajaxOptions, thrownError) {
                console.log('error', xhr, ajaxOptions, thrownError);
            }
        });
        
    },
};